<template>
  <div class="layout">
    <div class="layout__header">
      <h3>Comprobantes</h3>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-field">
          <div class="form-group">
            <input-field
              v-model="nombrePersona"
              readonly
              id="filtroPersona"
              placeholder="Seleccione una persona..."
            >
              Persona
            </input-field>
            <button
              @click="$modal.show('consultaPersonas')"
              v-show="form.id_persona === ''"
              class="btn-info"
              type="button"
            >
              <i class="fa fa-search"></i>
            </button>
            <button
              @click="quitarPersona"
              v-show="form.id_persona !== ''"
              class="btn-danger"
              type="button"
            >
              <i class="fa fa-ban"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <k-table
      ref="tablaComprobantes"
      fechas
      buscarNumero
      :tipoComprobante="tipoComprobante"
      :createButton="false"
      :editButton="false"
      :deleteButton="false"
      @seleccionar="seleccionar"
      :path="path"
      :params="form"
      :columns="[
        {
          display: 'Fecha de emisión',
          value: 'fecha_emision',
        },
        {
          display: 'N° establecimiento',
          value: 'numero_establecimiento',
        },
        {
          display: 'N° emisor',
          value: 'punto_emision',
        },
        {
          display: 'N° Secuencial',
          value: 'numero_documento',
        },
        {
          display: 'Proveedor',
          value: 'razon_social',
        },
        {
          display: 'N° Identificación del proveedor',
          value: 'ruc',
        },
        {
          display: 'Total sin impuestos',
          value: 'total_sin_impuestos',
          numeric: true,
          hidden: tipoComprobante === '07',
        },
        {
          display: 'IVA',
          value: 'valor_iva',
          numeric: true,
          hidden: tipoComprobante === '07',
        },
        {
          display: 'ICE',
          value: 'valor_ice',
          numeric: true,
          hidden: tipoComprobante === '07',
        },
        {
          display: 'IRBPNR',
          value: 'valor_irbpnr',
          numeric: true,
          hidden: tipoComprobante === '07',
        },
        {
          display: 'Total',
          value: 'total',
          numeric: true,
        },
        {
          display: 'Estado',
          value: 'descripcion_estado',
        },
      ]"
    ></k-table>
    <modal width="55%" height="auto" name="consultaPersonas" scrollable>
      <lista-personas
        :createButton="false"
        :tipoFiltro="tipoComprobante === '07' ? 'C' : 'P'"
        :filterStatus="false"
        @selected="selectedPersona"
      ></lista-personas>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    tipoComprobante: {
      type: String,
      default: "01",
      required: false,
    },
  },
  data: function () {
    return {
      comprobantes: [],
      form: {
        tipo_comprobante: this.tipoComprobante,
        id_persona: "",
      },
      path: url + "/compras/search",
      url: url,
      nombrePersona: "",
    };
  },
  methods: {
    seleccionar: function (currentComprobante) {
      this.$emit("selected", currentComprobante);
    },
    selectedPersona: function (persona) {
      this.nombrePersona = persona.nombre;
      this.form.id_persona = persona.id;
      this.$modal.hide("consultaPersonas");
      this.$refs.tablaComprobantes.loadRows();
    },
    quitarPersona: function () {
      this.nombrePersona = "";
      this.form.id_persona = "";
      this.$refs.tablaComprobantes.loadRows();
    },
  },
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/compras/ListaComprobantesCompra.vue